// extracted by mini-css-extract-plugin
module.exports = {"service":"RequestMostSearchedServices_service__7MtAx","online":"RequestMostSearchedServices_online__H5YJ2"};